var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFavoriteFilled(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "favorite-filled-icon",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 29.11 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.26,13.36l-5.43,3.93,1.98,6.68c.49,2.12-1.8,3.8-3.68,2.67h0l-5.57-3.37-5.57,3.36h0c-1.88,1.14-4.17-.55-3.68-2.67h0l1.48-6.34L1.86,13.35h0c-1.65-1.43-.77-4.14,1.41-4.32h0l6.48-.55,2.54-5.97h0c.84-2.01,3.7-2.01,4.54,0h0l2.54,5.99,6.48,.55h0c2.18,.18,3.06,2.89,1.41,4.32Z",
    fill: "currentColor",
    strokeWidth: 2
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavoriteFilled);
export default __webpack_public_path__ + "static/media/favorite-filled.5e215db8d6bc8b330c030a40d79826ac.svg";
export { ForwardRef as ReactComponent };